var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 4.5V3H16.5V4.5V6.13776C13.1956 6.74992 10.5 9.34413 10.5 12.75C10.5 16.1559 13.1956 18.7501 16.5 19.3622V26.7905C14.6637 26.2529 13.5 24.7605 13.5 23.25H10.5C10.5 26.6559 13.1956 29.2501 16.5 29.8622V31.5V33H19.5V31.5V29.8622C22.8044 29.2501 25.5 26.6559 25.5 23.25C25.5 19.8441 22.8044 17.2499 19.5 16.6378V9.20952C21.3363 9.74708 22.5 11.2395 22.5 12.75H25.5C25.5 9.34413 22.8044 6.74992 19.5 6.13776V4.5ZM16.5 9.20952C14.6637 9.74708 13.5 11.2395 13.5 12.75C13.5 14.2605 14.6637 15.7529 16.5 16.2905V9.20952ZM19.5 19.7095V26.7905C21.3363 26.2529 22.5 24.7605 22.5 23.25C22.5 21.7395 21.3363 20.2471 19.5 19.7095Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "percent",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5L5 19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 2.5
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "hash",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4L5 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4L12 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9L20 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15L18 15"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_up_big",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64285 28.5L25.4679 12.675L25.4786 21L28.5 21L28.5 7.49999L15 7.49999L15 10.5214L23.325 10.5321L7.5 26.3571L9.64285 28.5Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_big",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4L3 12L11 20",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H3",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_down",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19h11V8M5 5l14 14",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_left",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 6L5 12L11 18",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12H5",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42857 20L17.9786 7.44999L17.9857 16L20 16L20 3.99999L8 3.99999L8 6.01428L16.55 6.02142L4 18.5714L5.42857 20Z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_right",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5L21 12.5L13 20.5",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.5H2",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "geography",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 63L1 57V16l12 6v41zm38 0l-19-6-19 6m32-49c0 10-13 27-13 27S19 24 19 14c0-7.18 5.82-13 13-13s13 5.82 13 13zM32 57V44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20a6 6 0 100-12 6 6 0 000 12zm0 0v11M7 34v2m0 2v2m0 2v2m6-22l4-1m34 42l12-6V16l-12 6v41zm6-29v2m0 2v2m0 2v2m-6-22l-4-1"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "daypart",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M32 35a3 3 0 100-6 3 3 0 000 6zm3-3h9m-12-3V14m0 40v9m0-62v9M1 32h9m44 0h9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M55.005 44.127A25.887 25.887 0 0058 32c0-4.38-1.083-8.506-2.995-12.127l1.733-1A27.877 27.877 0 0160 32c0 4.744-1.18 9.212-3.262 13.128l-1.733-1.001zM44.127 55.004A25.886 25.886 0 0132 58c-4.38 0-8.506-1.083-12.127-2.995l-1 1.733A27.878 27.878 0 0032 60c4.744 0 9.212-1.18 13.128-3.262l-1.001-1.733zm1.731-1.001l1 1.733a28.147 28.147 0 008.879-8.877l-1.734-1a26.136 26.136 0 01-8.145 8.144zm9.879-36.862a28.147 28.147 0 00-8.878-8.877l-1 1.733a26.137 26.137 0 018.144 8.145l1.733-1.001zm-10.61-9.88A27.877 27.877 0 0032 4c-4.744 0-9.212 1.18-13.128 3.262l1.001 1.733A25.887 25.887 0 0132 6c4.38 0 8.506 1.083 12.127 2.995l1-1.733zm-36.863 9.88a28.146 28.146 0 018.877-8.877l1 1.733a26.137 26.137 0 00-8.144 8.145l-1.733-1zM4 32c0-4.744 1.18-9.212 3.262-13.128l1.733 1.001A25.887 25.887 0 006 32c0 4.38 1.083 8.506 2.995 12.127l-1.733 1A27.877 27.877 0 014 32zm13.141 23.736a28.145 28.145 0 01-8.877-8.877l1.733-1a26.136 26.136 0 008.145 8.144l-1.001 1.733z",
    clipRule: "evenodd"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "consumer_dynamics",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 44v-6m12 6v-6m5-14h-1a2 2 0 01-2-2v-2a2 2 0 00-2-2v-2l-4 2h-8a2 2 0 00-2 2v2a2 2 0 01-2 2m0 0h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16v11l1 1c0 5 3 12 10 12s10-7 10-12l1-1V14a4 4 0 00-4-4H28c-1.656 0-3 1.344-3 3h-1c-1.656 0-3 1.344-3 3zm7 36l-9-4 5-4 8 2v2l-4 4zm8 0l9-4-5-4-8 2v2l4 4zm-4 5v2m0-6v2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M58 49c3.207-4.881 5-10.723 5-17C63 14.879 49.121 1 32 1 14.879 1 1 14.879 1 32c0 6.278 1.792 12.118 5 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 48l3 1c6 2 6 5 6 5-5.617 5.674-13.384 9-22 9-8.553 0-16.391-3.398-22-9 0 0 0-3 6-5l3-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7 44l-1 5-5-1m56-4l1 5 5-1"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "competition",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.065 51.703A30.876 30.876 0 011 32C1 14.879 14.879 1 32 1c17.121 0 31 13.879 31 31M32 63a30.871 30.871 0 01-19.715-7.076m36.627-2.875A26.894 26.894 0 0132 59a26.877 26.877 0 01-13.998-3.907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.088 22A26.949 26.949 0 0159 32c0 6.375-2.21 12.234-5.904 16.854M32 5a26.887 26.887 0 0116.998 6.021M8.911 46.005A26.874 26.874 0 015 32m17.524-20.964A22.938 22.938 0 0132 9c12.703 0 23 10.297 23 23 0 3.73-.889 7.255-2.465 10.371M42.437 52.503A22.91 22.91 0 0132 55C19.297 55 9 44.703 9 32a22.89 22.89 0 012.976-11.323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.377 16.244A18.915 18.915 0 0132 13c7.801 0 14.504 4.701 17.43 11.426M13.968 38.004A18.977 18.977 0 0113 32c0-4.426 1.513-8.497 4.05-11.728m32.622 18.721C46.886 46.025 40.023 51 32 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.703 34.984C45.319 41.84 39.262 47 32 47c-8.284 0-15-6.716-15-15m15-15c7.248 0 13.296 5.142 14.695 11.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39a7 7 0 100-14 7 7 0 000 14zM10 57a3 3 0 100-6 3 3 0 000 6zm37-22a3 3 0 100-6 3 3 0 000 6zm4 19a3 3 0 100-6 3 3 0 000 6zM19 21a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33a1 1 0 100-2 1 1 0 000 2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand_kpis",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0V64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 59H64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 45L17 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 56V54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 33L28 28H42L61 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11H23L29 17L35 11H40L47 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 23L61 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32H61V27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 14V9H56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 48L61 44L57 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 44H44L38 38L30 46L11 27"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8l-8 8-8-8"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11l7 7L22 6"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_giant",
    viewBox: "0 0 280 280",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 140.5L120.5 178L196.5 102"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "save",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.586 4H5a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V7.414a1 1 0 00-.293-.707l-2.414-2.414A1 1 0 0016.586 4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8 12h8m-8 4h8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h8v3a1 1 0 01-1 1H9a1 1 0 01-1-1V5z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "blank",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M5 4v16a1 1 0 001 1h12a1 1 0 001-1V7.414a1 1 0 00-.293-.707l-3.414-3.414A1 1 0 0014.586 3H6a1 1 0 00-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V3l5 5h-4a1 1 0 01-1-1z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9v6a2 2 0 01-2 2v2h16v-2a2 2 0 01-2-2V9A6 6 0 006 9zm7 4v3h-2v-3H8v-2h3V8h2v3h3v2h-3zm-1 9a2 2 0 002-2h-4a2 2 0 002 2z",
    clipRule: "evenodd"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "bar_chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5H8v16h3V5zm-5 8H3v8h3v-8zm7-5h3v13h-3V8zm8 3h-3v10h3V11z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "line_chart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3v17a1 1 0 001 1h17v-2H5V3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.77 14.098a.985.985 0 001.374 0L21 9.344 19.627 8l-4.17 4.082-2.227-2.18a.985.985 0 00-1.374 0L7 14.656 8.373 16l4.17-4.082 2.227 2.18z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.13 3 5 6.13 5 10C5 15.25 12 21 12 21C12 21 19 15.25 19 10C19 6.13 15.87 3 12 3ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18L18 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_big",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 20 20 4M4 4l16 16"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_giant",
    viewBox: "0 0 280 280",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 183.5L183.5 97",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 97L183.5 183.5",
    strokeWidth: 4
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_right",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6L15 12L9 18",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "command",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15.3 8.1C15.1 7.9 14.8 7.9 14.6 8.1L8.1 14.6C7.9 14.8 7.9 15.1 8.1 15.3L8.6 15.8C8.8 16 9.1 16 9.3 15.8L15.8 9.3C16 9.1 16 8.8 15.8 8.6L15.3 8.1Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 11L10 16L19 7",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 15-5-6-5 6h10Z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_settings",
    viewBox: "0 0 16 16",
    ill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4666 9.38276L14 9.82364C14.253 10.0293 14.3207 10.388 14.16 10.672L13.3866 12.008C13.2267 12.2682 12.911 12.3864 12.62 12.2952L11.9533 12.0548C11.5599 11.9074 11.1202 11.9545 10.7666 12.1817C10.6099 12.2902 10.445 12.3862 10.2733 12.4689C9.89817 12.6617 9.63612 13.0209 9.56664 13.4375L9.45331 14.1055C9.40049 14.4322 9.1169 14.6709 8.78664 14.6666H7.2533C6.92304 14.6709 6.63946 14.4322 6.58664 14.1055L6.4733 13.4375C6.40382 13.0209 6.14177 12.6617 5.76664 12.4689C5.59497 12.3862 5.43002 12.2902 5.2733 12.1817C4.91978 11.9545 4.48007 11.9074 4.08664 12.0548L3.41997 12.2952C3.11714 12.408 2.77722 12.2869 2.6133 12.008L1.83997 10.672C1.67925 10.388 1.74692 10.0293 1.99997 9.82364L2.5333 9.38276C2.85667 9.1138 3.03455 8.70781 3.0133 8.28725V8.00001V7.71277C3.03455 7.29221 2.85667 6.88622 2.5333 6.61726L1.99997 6.17638C1.74692 5.97076 1.67925 5.61199 1.83997 5.32802L2.6133 3.99203C2.776 3.71951 3.10767 3.59942 3.40664 3.70479L4.0733 3.94527C4.46673 4.0926 4.90644 4.04557 5.25997 3.81835C5.41669 3.70986 5.58164 3.61382 5.7533 3.53111C6.1182 3.33204 6.36963 2.9739 6.4333 2.56251L6.54664 1.89452C6.59946 1.56783 6.88304 1.32914 7.2133 1.3334H8.74664C9.0769 1.32914 9.36049 1.56783 9.4133 1.89452L9.52664 2.56251C9.59612 2.97917 9.85817 3.33835 10.2333 3.53111C10.405 3.61382 10.5699 3.70986 10.7266 3.81835C11.0802 4.04557 11.5199 4.0926 11.9133 3.94527L12.58 3.70479C12.8828 3.59205 13.2227 3.71309 13.3866 3.99203L14.16 5.32802C14.3207 5.61199 14.253 5.97076 14 6.17638L13.4666 6.61726C13.1433 6.88622 12.9654 7.29221 12.9866 7.71277V8.00001V8.28725C12.9654 8.70781 13.1433 9.1138 13.4666 9.38276ZM5.99996 8.00001C5.99996 9.10678 6.89539 10.004 7.99996 10.004C8.53039 10.004 9.0391 9.79286 9.41417 9.41704C9.78924 9.04122 9.99996 8.5315 9.99996 8.00001C9.99996 6.89323 9.10453 5.99602 7.99996 5.99602C6.89539 5.99602 5.99996 6.89323 5.99996 8.00001Z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "market_dynamics",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.065 51.703C3.651 46.347 1 39.482 1 32C1 14.879 14.879 1 32 1C49.121 1 63 14.879 63 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 63C24.512 63 17.643 60.345 12.285 55.924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.912 53.049C44.284 56.771 38.402 59 32 59C26.875 59 22.083 57.572 18.002 55.093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.088 22C58.321 25.094 59 28.467 59 32C59 38.375 56.79 44.234 53.096 48.854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 5C38.442 5 44.357 7.256 48.998 11.021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.911 46.005C6.429 41.922 5 37.128 5 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.524 11.036C25.414 9.729 28.622 9 32 9C44.703 9 55 19.297 55 32C55 35.73 54.111 39.255 52.535 42.371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.437 52.503C39.305 54.1 35.758 55 32 55C19.297 55 9 44.703 9 32C9 27.884 10.081 24.02 11.976 20.677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.377 16.244C24.409 14.196 28.065 13 32 13C39.801 13 46.504 17.701 49.43 24.426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.968 38.004C13.34 36.117 13 34.099 13 32C13 27.574 14.513 23.503 17.05 20.272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.672 38.993C46.886 46.025 40.023 51 32 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.703 34.984C45.319 41.84 39.262 47 32 47C23.716 47 17 40.284 17 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 17C39.248 17 45.296 22.142 46.695 28.977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 39C35.866 39 39 35.866 39 32C39 28.134 35.866 25 32 25C28.134 25 25 28.134 25 32C25 35.866 28.134 39 32 39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 57C11.6569 57 13 55.6569 13 54C13 52.3431 11.6569 51 10 51C8.34315 51 7 52.3431 7 54C7 55.6569 8.34315 57 10 57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 35C48.6569 35 50 33.6569 50 32C50 30.3431 48.6569 29 47 29C45.3431 29 44 30.3431 44 32C44 33.6569 45.3431 35 47 35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 54C52.6569 54 54 52.6569 54 51C54 49.3431 52.6569 48 51 48C49.3431 48 48 49.3431 48 51C48 52.6569 49.3431 54 51 54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21C20.6569 21 22 19.6569 22 18C22 16.3431 20.6569 15 19 15C17.3431 15 16 16.3431 16 18C16 19.6569 17.3431 21 19 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33C32.5523 33 33 32.5523 33 32C33 31.4477 32.5523 31 32 31C31.4477 31 31 31.4477 31 32C31 32.5523 31.4477 33 32 33Z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "market_performance",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60 12H12v6h48v-6Zm3 30v-6l-3-15H12L9 36v6h3v18h30V42h12v18h6V42h3ZM36 54H18V42h18v12Z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "asc",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8L5 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5L8.4641 9.5H1.5359L5 5Z",
    fill: "currentColor",
    strokeWidth: 0
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "desc",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17H18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5V16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19L1.5359 14.5L8.4641 14.5L5 19Z",
    fill: "currentColor",
    strokeWidth: 0
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 12.6667V3.33333",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8H12.6673",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus_small",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 17V7M7 12h10"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 8H12.6663",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "gender",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.05c.94 0 1.75-.34 2.42-1.02.67-.68 1-1.5 1-2.47a3.4 3.4 0 0 0-1-2.46A3.27 3.27 0 0 0 12 8.07c-.94 0-1.75.34-2.42 1.03-.67.68-1 1.5-1 2.46s.33 1.79 1 2.47A3.27 3.27 0 0 0 12 15.05Zm-.64 6.55v-1.75H9.64v-1.3h1.72v-2.2a4.83 4.83 0 0 1-4.07-4.79 5.01 5.01 0 0 1 .94-2.9l-.9-.91-1.2 1.22-.9-.92 1.2-1.22-2.14-2.18V7.2H3V2.4h4.71v1.3h-2.5l2.14 2.2 1.2-1.23.9.92-1.2 1.22.92.94A4.74 4.74 0 0 1 12 6.76a4.76 4.76 0 0 1 2.85.96l3.94-4.01h-2.5V2.4H21v4.8h-1.29V4.65l-3.94 4.01a4.64 4.64 0 0 1 .94 2.9 4.83 4.83 0 0 1-4.07 4.78v2.2h1.72v1.31h-1.72v1.75h-1.28Z",
    fill: "currentColor"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "income",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.03 18.93h1.5v-1.3a4.12 4.12 0 0 0 2.28-.94c.58-.51.87-1.21.87-2.11 0-.8-.23-1.48-.68-2.03a6.01 6.01 0 0 0-2.42-1.53 9.55 9.55 0 0 1-2.1-1 1.4 1.4 0 0 1-.63-1.2c0-.48.18-.86.53-1.14.35-.29.84-.43 1.47-.43.52 0 .95.12 1.29.36.34.24.62.58.84 1.01l1.32-.6a3.51 3.51 0 0 0-1.09-1.42 3.02 3.02 0 0 0-1.63-.62V4.7h-1.5v1.28c-.85.13-1.52.46-2 .98a2.66 2.66 0 0 0-.73 1.87c0 .81.24 1.46.73 1.95.48.48 1.22.91 2.22 1.3 1.1.45 1.85.85 2.26 1.2.41.35.62.78.62 1.3 0 .55-.22.97-.64 1.27-.43.3-.95.45-1.56.45a2.7 2.7 0 0 1-1.65-.54 2.87 2.87 0 0 1-1.03-1.51l-1.4.5a4.2 4.2 0 0 0 3.12 2.82v1.36Zm.77 2.87a10.14 10.14 0 0 1-9.21-6.13 9.67 9.67 0 0 1-.79-3.87 9.99 9.99 0 0 1 10-10 10.1 10.1 0 0 1 9.21 6.1c.53 1.22.79 2.52.79 3.9 0 1.37-.26 2.66-.79 3.88a9.99 9.99 0 0 1-9.21 6.13Z",
    fill: "currentColor"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "ethnicity",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM18.92 11H16.35C16.2943 9.1973 15.8937 7.42197 15.17 5.77C17.1948 6.80134 18.593 8.75135 18.92 11ZM12 19H12.45C13.36 18.41 14.41 16.22 14.59 13H9.41C9.55 16.24 10.64 18.43 11.55 19H12ZM9.45 11C9.63 7.78 10.68 5.59 11.59 5H12H12.45C13.36 5.57 14.45 7.76 14.59 11H9.45ZM7.65 11C7.70571 9.1973 8.10626 7.42197 8.83 5.77C6.80522 6.80134 5.40704 8.75135 5.08 11H7.65ZM5.08 13H7.65C7.70571 14.8027 8.10626 16.578 8.83 18.23C6.80522 17.1987 5.40704 15.2487 5.08 13ZM16.35 13C16.2943 14.8027 15.8937 16.578 15.17 18.23C17.1948 17.1987 18.593 15.2487 18.92 13H16.35Z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "relationship",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95 21.8v-7.5H3.6V8.68c0-.52.19-.96.56-1.33.38-.37.81-.55 1.31-.55h2.76c.5 0 .93.18 1.3.55.36.37.55.8.55 1.33v5.62H8.75v7.5h-3.8Zm1.9-16.22c-.52 0-.96-.2-1.34-.57a1.83 1.83 0 0 1-.56-1.34c0-.51.19-.95.56-1.32.38-.37.82-.55 1.34-.55.52 0 .96.18 1.32.55.37.37.56.8.56 1.32s-.19.97-.56 1.34c-.36.38-.8.57-1.32.57Zm8.22 16.22v-6h-2.72l2.28-7.72c.11-.42.34-.74.68-.96.34-.21.73-.32 1.17-.32.43 0 .82.1 1.16.32.34.22.57.54.69.96l2.27 7.72h-2.72v6h-2.8Zm1.4-16.22c-.51 0-.95-.2-1.32-.57a1.85 1.85 0 0 1-.55-1.34c0-.51.18-.95.55-1.32.37-.37.8-.55 1.33-.55.51 0 .95.18 1.32.55.37.37.55.8.55 1.32s-.18.97-.55 1.34c-.37.38-.8.57-1.32.57Z",
    fill: "currentColor"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "education",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.52 16.95v-7L12.17 15 1.2 9l10.97-6L23.2 9v7.95h-1.68ZM12.17 21l-7.15-3.93v-5.14l7.15 3.9 7.18-3.9v5.14L12.17 21Z",
    fill: "currentColor"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "hispanic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 1C10.8953 1 9.9999 1.89543 9.9999 3C9.9999 4.10457 10.8953 5 11.9999 5C13.1045 5 13.9999 4.10457 13.9999 3C13.9999 1.89543 13.1045 1 11.9999 1ZM15.6699 7.44L19.4499 12C19.6094 12.2097 19.5787 12.5072 19.3799 12.68L18.6199 13.32C18.4062 13.4961 18.091 13.4694 17.9099 13.26L14.9999 9.76V22.5C14.9999 22.7761 14.776 23 14.4999 23H13.4999C13.2238 23 12.9999 22.7761 12.9999 22.5V15H10.9999V22.5C10.9999 22.7761 10.776 23 10.4999 23H9.4999C9.22376 23 8.9999 22.7761 8.9999 22.5V9.76L6.0899 13.28C5.90876 13.4894 5.59362 13.5161 5.3799 13.34L4.6199 12.7C4.40861 12.5253 4.37738 12.2131 4.5499 12L8.3299 7.44C9.09133 6.52584 10.2202 5.99807 11.4099 6H12.5899C13.7796 5.99807 14.9085 6.52584 15.6699 7.44Z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "age",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21.8a.97.97 0 0 1-.71-.29.97.97 0 0 1-.29-.71v-4.98c0-.46.16-.86.49-1.18.32-.33.72-.49 1.19-.49h14.64c.47 0 .87.16 1.2.49.32.32.48.72.48 1.18v4.98c0 .28-.1.52-.29.71-.19.2-.43.29-.71.29H4Zm1.13-9.32V9.45c0-.47.16-.86.48-1.19.33-.32.72-.48 1.17-.48h4.4V6.22a2.49 2.49 0 0 1-.77-.73 1.85 1.85 0 0 1-.26-1.01 1.87 1.87 0 0 1 .55-1.33L12 1.8l1.3 1.35c.18.18.32.39.42.61.1.23.15.47.15.72 0 .4-.09.73-.27 1-.18.28-.44.53-.78.74v1.56h4.4c.45 0 .84.16 1.17.48.32.33.48.72.48 1.19v3.03H5.13Z",
    fill: "currentColor"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "employment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7H17V5C17 3.89543 16.1046 3 15 3H9C7.89543 3 7 3.89543 7 5V7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7ZM14 14C14 14.5523 13.5523 15 13 15H11C10.4477 15 10 14.5523 10 14V13.5C10 13.2239 10.2239 13 10.5 13H13.5C13.7761 13 14 13.2239 14 13.5V14ZM9 7H15V5H9V7Z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "household_size",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 19C22.7761 19 23 19.2239 23 19.5V20.5C23 20.7761 22.7761 21 22.5 21H1.5C1.22386 21 1 20.7761 1 20.5V19.5C1 19.2239 1.22386 19 1.5 19H4V12C4 11.4477 4.44772 11 5 11H9V4C9 3.44772 9.44771 3 10 3H14C14.5523 3 15 3.44772 15 4V7H19C19.5523 7 20 7.44772 20 8V19H22.5ZM17.5 9H16.5C16.2239 9 16 9.22386 16 9.5V10.5C16 10.7761 16.2239 11 16.5 11H17.5C17.7761 11 18 10.7761 18 10.5V9.5C18 9.22386 17.7761 9 17.5 9ZM16.5 13H17.5C17.7761 13 18 13.2239 18 13.5V14.5C18 14.7761 17.7761 15 17.5 15H16.5C16.2239 15 16 14.7761 16 14.5V13.5C16 13.2239 16.2239 13 16.5 13ZM17.5 17H16.5C16.2239 17 16 17.2239 16 17.5V18.5C16 18.7761 16.2239 19 16.5 19H17.5C17.7761 19 18 18.7761 18 18.5V17.5C18 17.2239 17.7761 17 17.5 17ZM11.5 9H12.5C12.7761 9 13 9.22386 13 9.5V10.5C13 10.7761 12.7761 11 12.5 11H11.5C11.2239 11 11 10.7761 11 10.5V9.5C11 9.22386 11.2239 9 11.5 9ZM12.5 13H11.5C11.2239 13 11 13.2239 11 13.5V14.5C11 14.7761 11.2239 15 11.5 15H12.5C12.7761 15 13 14.7761 13 14.5V13.5C13 13.2239 12.7761 13 12.5 13ZM13 5.5V6.5C13 6.77614 12.7761 7 12.5 7H11.5C11.2239 7 11 6.77614 11 6.5V5.5C11 5.22386 11.2239 5 11.5 5H12.5C12.7761 5 13 5.22386 13 5.5ZM6.5 19H7.5C7.77614 19 8 18.7761 8 18.5V17.5C8 17.2239 7.77614 17 7.5 17H6.5C6.22386 17 6 17.2239 6 17.5V18.5C6 18.7761 6.22386 19 6.5 19ZM7.5 15H6.5C6.22386 15 6 14.7761 6 14.5V13.5C6 13.2239 6.22386 13 6.5 13H7.5C7.77614 13 8 13.2239 8 13.5V14.5C8 14.7761 7.77614 15 7.5 15ZM11 17.5V18.5C11 18.7761 11.2239 19 11.5 19H12.5C12.7761 19 13 18.7761 13 18.5V17.5C13 17.2239 12.7761 17 12.5 17H11.5C11.2239 17 11 17.2239 11 17.5Z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "restaurant_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.76V2.5C12 2.22386 11.7761 2 11.5 2H10.75C10.4739 2 10.25 2.22386 10.25 2.5V9.5C10.25 9.77614 10.0261 10 9.75 10H9.38C9.10386 10 8.88 9.77614 8.88 9.5V2.5C8.88 2.22386 8.65614 2 8.38 2H7.62C7.34386 2 7.12 2.22386 7.12 2.5V9.5C7.12 9.77614 6.89614 10 6.62 10H6.25C5.97386 10 5.75 9.77614 5.75 9.5V2.5C5.75 2.22386 5.52614 2 5.25 2H4.5C4.22386 2 4 2.22386 4 2.5V10.76C4.0007 11.5554 4.31723 12.3179 4.88 12.88L5.71 13.71C5.89626 13.8947 6.14766 13.9989 6.41 14H7V21.5C7 21.7761 7.22386 22 7.5 22H8.5C8.77614 22 9 21.7761 9 21.5V14H9.59C9.85234 13.9989 10.1037 13.8947 10.29 13.71L11.12 12.88C11.6828 12.3179 11.9993 11.5554 12 10.76ZM19.5 2C19.7761 2 20 2.22386 20 2.5V21.5C20 21.7761 19.7761 22 19.5 22H18.5C18.2239 22 18 21.7761 18 21.5V14H16C15.4477 14 15 13.5523 15 13V6C15 3.79086 16.7909 2 19 2H19.5Z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "customer_segments",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1223 8.79501C10.1223 8.66169 10.0684 8.53389 9.97259 8.44001L6.77316 5.27001L8.21088 3.85001C8.35395 3.70586 8.39522 3.49088 8.31551 3.305C8.23581 3.11913 8.05076 2.99882 7.84639 3.00001H3.54336C3.26819 3.01028 3.04751 3.22823 3.03712 3.50001V7.75001C3.03587 7.95447 3.16078 8.13907 3.35252 8.21615C3.54426 8.29322 3.76419 8.24722 3.90785 8.10001L5.34557 6.68001L8.545 9.85001C8.64005 9.94466 8.76944 9.99791 8.90443 9.99791C9.03941 9.99791 9.1688 9.94466 9.26386 9.85001L9.97259 9.15001C10.0684 9.05613 10.1223 8.92833 10.1223 8.79501ZM8.90443 14.0021C9.03941 14.0021 9.1688 14.0554 9.26386 14.15L9.97259 14.85C10.0684 14.9439 10.1223 15.0717 10.1223 15.205C10.1223 15.3383 10.0684 15.4661 9.97259 15.56L6.76304 18.72L8.20075 20.15C8.34256 20.2929 8.38451 20.5054 8.30738 20.6904C8.23026 20.8754 8.04892 20.9972 7.84639 21H3.54336C3.26819 20.9897 3.04751 20.7718 3.03712 20.5V16.25C3.03592 16.0482 3.15773 15.8654 3.34592 15.7867C3.53411 15.7079 3.75177 15.7487 3.89772 15.89L5.33544 17.31L8.545 14.15C8.64005 14.0554 8.76944 14.0021 8.90443 14.0021ZM20.4011 15.9L18.9634 17.32L15.764 14.15C15.6689 14.0554 15.5395 14.0021 15.4045 14.0021C15.2695 14.0021 15.1402 14.0554 15.0451 14.15L14.3364 14.85C14.2405 14.9439 14.1866 15.0717 14.1866 15.205C14.1866 15.3383 14.2405 15.4661 14.3364 15.56L17.5358 18.73L16.0981 20.15C15.955 20.2942 15.9137 20.5091 15.9934 20.695C16.0731 20.8809 16.2582 21.0012 16.4626 21H20.7555C21.0306 20.9897 21.2513 20.7718 21.2617 20.5V16.25C21.263 16.0456 21.1381 15.8609 20.9463 15.7839C20.7546 15.7068 20.5346 15.7528 20.391 15.9H20.4011ZM16.4524 3.00001H20.7555C21.0306 3.01028 21.2513 3.22823 21.2617 3.50001V7.75001C21.2629 7.95186 21.1411 8.13463 20.9529 8.21335C20.7647 8.29208 20.5471 8.25131 20.4011 8.11001L18.9634 6.69001L15.7538 9.85001C15.6588 9.94466 15.5294 9.99791 15.3944 9.99791C15.2594 9.99791 15.13 9.94466 15.035 9.85001L14.3262 9.15001C14.2304 9.05613 14.1765 8.92833 14.1765 8.79501C14.1765 8.66169 14.2304 8.53389 14.3262 8.44001L17.5358 5.27001L16.0981 3.85001C15.9563 3.70716 15.9143 3.49457 15.9914 3.30958C16.0686 3.1246 16.2499 3.00282 16.4524 3.00001Z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "category_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross-category_wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "segment",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9598 10.949H21.9998C21.5288 6.232 17.7678 2.471 13.0508 2V6.04C15.5578 6.463 17.5368 8.442 17.9598 10.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0508 17.949C8.74178 17.949 6.05078 15.258 6.05078 11.949C6.05078 8.982 8.21778 6.517 11.0508 6.04V2C6.00478 2.504 2.05078 6.773 2.05078 11.949C2.05078 17.463 6.53678 21.949 12.0508 21.949C17.2268 21.949 21.4958 17.995 21.9998 12.949H17.9598C17.4818 15.782 15.0178 17.949 12.0508 17.949Z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "market",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V20C3 20.553 3.447 21 4 21H21V19H5V3H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7702 14.0984C15.15 14.4702 15.7638 14.4702 16.1436 14.0984L21 9.34443L19.6266 8L15.4569 12.0818L13.2298 9.90159C12.85 9.52983 12.2362 9.52983 11.8564 9.90159L7 14.6556L8.37339 16L12.5431 11.9182L14.7702 14.0984Z"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.74 8.16L17.59 3.65C17.2125 3.23731 16.6794 3.00158 16.12 3H7.88003C7.32069 3.00158 6.78758 3.23731 6.41003 3.65L2.26003 8.16C2.091 8.34595 1.99818 8.58872 2.00003 8.84V9.14C1.99957 9.37365 2.08095 9.60009 2.23003 9.78L11.23 20.64C11.4204 20.8685 11.7026 21.0005 12 21C12.2975 21.0005 12.5797 20.8685 12.77 20.64L21.77 9.78C21.9191 9.60009 22.0005 9.37365 22 9.14V8.84C22.0019 8.58872 21.9091 8.34595 21.74 8.16ZM11.18 17.47L4.53003 9.47C4.40024 9.41753 4.33756 9.26979 4.39003 9.14C4.44249 9.01021 4.59024 8.94753 4.72003 9H8.27003C8.72089 8.97794 9.13063 9.26066 9.27003 9.69L11.66 17.24C11.7235 17.3725 11.6676 17.5315 11.535 17.595C11.4025 17.6585 11.2435 17.6025 11.18 17.47ZM13.07 9H19.24C19.3388 8.9987 19.4276 8.93933 19.4665 8.8485C19.5055 8.75768 19.4872 8.65244 19.42 8.58L16.31 5.2C16.2626 5.14787 16.1955 5.11815 16.125 5.11815C16.0546 5.11815 15.9874 5.14787 15.94 5.2L12.88 8.58C12.8115 8.65377 12.794 8.76142 12.8355 8.85313C12.877 8.94485 12.9694 9.00273 13.07 9Z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "wallet_share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H19C19 3.89543 18.1046 3 17 3H6C4.34315 3 3 4.34315 3 6V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7ZM5 19V9H19V11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H19V19H5ZM15 14.5V13.5C15 13.2239 14.7761 13 14.5 13H13.5C13.2239 13 13 13.2239 13 13.5V14.5C13 14.7761 13.2239 15 13.5 15H14.5C14.7761 15 15 14.7761 15 14.5Z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "categories",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 17.1435 15.2625 15.363 13.9497 14.0503C12.637 12.7375 10.8565 12 9 12C7.14349 12 5.36301 12.7375 4.05025 14.0503C2.7375 15.363 2 17.1435 2 19L9 19H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1338 13.5122C17.3376 15.0769 18.0004 17.0043 18.0004 19H22.0004C22.0004 17.5413 21.421 16.1424 20.3895 15.1109C19.3581 14.0795 17.9591 13.5 16.5004 13.5C16.3777 13.5 16.2555 13.5041 16.1338 13.5122Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 2.5
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.039 23.974l-3.332-2.606c.044-.401.078-.871.078-1.368 0-.497-.036-.967-.078-1.368l3.335-2.607c.62-.49.79-1.358.394-2.082l-3.465-5.995c-.379-.69-1.23-1.006-2.004-.72l-3.932 1.578a13.411 13.411 0 00-2.359-1.37l-.598-4.17a1.604 1.604 0 00-1.601-1.391h-6.948c-.814 0-1.503.598-1.6 1.376l-.6 4.185c-.79.358-1.569.81-2.356 1.372L8.031 7.225a1.606 1.606 0 00-1.989.708l-3.47 6.004a1.62 1.62 0 00.393 2.09l3.332 2.605c-.053.51-.078.953-.078 1.368 0 .416.026.858.075 1.369L2.96 23.977c-.617.49-.787 1.358-.392 2.081l3.465 5.995c.376.689 1.224 1.003 2.004.72l3.931-1.578a13.613 13.613 0 002.361 1.37l.598 4.169a1.604 1.604 0 001.601 1.391h6.948c.814 0 1.503-.598 1.6-1.376l.6-4.184c.79-.358 1.569-.81 2.356-1.371l3.942 1.583c.75.291 1.611-.017 1.99-.709l3.482-6.025a1.633 1.633 0 00-.406-2.07zm-.914 1.329l-3.598 6.069-4.324-1.737a.758.758 0 00-.734.097c-.937.7-1.841 1.227-2.769 1.607a.754.754 0 00-.462.592l-.763 4.684-7.049-.08-.66-4.603a.758.758 0 00-.462-.592 12.037 12.037 0 01-2.763-1.602.752.752 0 00-.743-.103L7.35 31.313l-3.465-5.995c-.032-.059-.026-.127.01-.155l3.666-2.866a.757.757 0 00.284-.689A12.742 12.742 0 017.73 20c0-.464.038-.974.116-1.609a.755.755 0 00-.284-.688l-3.683-3.005L7.476 8.63l4.324 1.737c.246.1.522.061.735-.097.935-.702 1.841-1.228 2.769-1.607a.758.758 0 00.46-.592l.765-4.686 7.05.082.66 4.604c.038.266.213.49.461.592a11.99 11.99 0 012.763 1.602.75.75 0 00.741.102l4.449-1.678 3.465 5.994c.031.06.025.126-.01.154l-3.667 2.866a.755.755 0 00-.284.688c.058.46.117 1.01.117 1.609 0 .6-.06 1.15-.117 1.609a.757.757 0 00.284.688l3.661 2.864c.04.032.047.1.023.142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001 12.448c-4.164 0-7.552 3.388-7.552 7.552s3.388 7.552 7.552 7.552c4.165 0 7.552-3.388 7.552-7.552s-3.387-7.552-7.552-7.552zm0 13.594A6.048 6.048 0 0113.96 20 6.048 6.048 0 0120 13.958 6.048 6.048 0 0126.043 20a6.048 6.048 0 01-6.042 6.042z"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "check_green",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20l6 6 11-11",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "hamb",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 7V5h18v2H3zm0 6h18v-2H3v2zm0 6h18v-2H3v2z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "minimaze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19h2v-5H5v2h3v3ZM16 16h3v-2h-5v5h2v-3ZM19 10V8h-3V5h-2v5h5ZM10 5H8v3H5v2h5V5Z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "brand_sample",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16 17.1435 15.2625 15.363 13.9497 14.0503C12.637 12.7375 10.8565 12 9 12C7.14349 12 5.36301 12.7375 4.05025 14.0503C2.7375 15.363 2 17.1435 2 19L9 19H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1334 13.5122C17.3372 15.0769 18.0001 17.0043 18.0001 19H22.0001C22.0001 17.5413 21.4206 16.1424 20.3891 15.1109C19.3577 14.0795 17.9587 13.5 16.5001 13.5C16.3774 13.5 16.2551 13.5041 16.1334 13.5122Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 2.5
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "geo",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.383 17.5458 17.1267 12.6462 21.4399C12.2772 21.7648 11.7228 21.7648 11.3538 21.4399C6.45419 17.1267 4 13.383 4 10.2C4 5.22 7.8 2 12 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "channel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.22089C3 8.07525 3.34728 8.89448 3.96572 9.49844C4.58397 10.1024 5.42258 10.4418 6.29715 10.4418H6.49494L7.85871 15.2438C7.18716 15.7577 6.7458 16.5059 6.62703 17.331C6.50849 18.1563 6.72174 18.9943 7.22227 19.6692C7.7228 20.3438 8.4715 20.803 9.31134 20.9496C10.151 21.0964 11.0162 20.9196 11.7251 20.4563C12.4341 19.9929 12.9317 19.2793 13.1134 18.465C13.2951 17.6509 13.1467 16.7995 12.6993 16.09L16.1881 12.4212C16.9809 12.8217 17.9059 12.8911 18.752 12.6138C19.5979 12.3364 20.2929 11.7357 20.6776 10.9492C21.0625 10.1626 21.1046 9.25724 20.7941 8.43985C20.4836 7.62245 19.8472 6.96296 19.0303 6.61207C18.2134 6.26098 17.2858 6.24852 16.4593 6.57735C15.6329 6.90618 14.978 7.54831 14.6446 8.35713L9.59413 7.26481V7.2209C9.59413 6.07018 8.96587 5.00688 7.94556 4.43152C6.92545 3.85616 5.66872 3.85616 4.64862 4.43152C3.62852 5.00688 3.00004 6.07018 3.00004 7.2209L3 7.22089ZM9.89382 19.2259C9.49637 19.2259 9.11521 19.0717 8.834 18.797C8.553 18.5224 8.39515 18.1501 8.39515 17.7618C8.39515 17.3736 8.553 17.0012 8.834 16.7265C9.11521 16.452 9.49635 16.2978 9.89382 16.2978C10.2913 16.2978 10.6724 16.452 10.9534 16.7265C11.2346 17.0012 11.3925 17.3736 11.3925 17.7618C11.3925 18.1501 11.2346 18.5224 10.9534 18.797C10.6724 19.0717 10.2913 19.2259 9.89382 19.2259ZM17.6868 8.09931C18.0843 8.09931 18.4657 8.25351 18.7467 8.52801C19.0276 8.80272 19.1855 9.17506 19.1855 9.56334C19.1855 9.95162 19.0276 10.3239 18.7467 10.5987C18.4657 10.8732 18.0843 11.0274 17.6868 11.0274C17.2894 11.0274 16.9082 10.8732 16.6272 10.5987C16.3462 10.324 16.1882 9.95162 16.1882 9.56334C16.1882 9.17506 16.3462 8.80273 16.6272 8.52801C16.9082 8.25351 17.2894 8.09931 17.6868 8.09931ZM14.4409 10.1168C14.5103 10.5071 14.6537 10.8815 14.8634 11.2205L11.3775 14.8894C10.918 14.6606 10.4097 14.5414 9.8939 14.5409C9.77368 14.5413 9.65367 14.5483 9.53408 14.5616L8.19433 9.85621C8.5437 9.61458 8.84186 9.30924 9.07265 8.95714L14.4409 10.1168ZM6.29731 5.75682C6.69477 5.75682 7.07592 5.91102 7.35692 6.18573C7.63791 6.46023 7.79597 6.83257 7.79597 7.22085C7.79597 7.60913 7.63791 7.98146 7.35692 8.25617C7.07592 8.53067 6.69478 8.68488 6.29731 8.68488C5.89986 8.68488 5.51849 8.53067 5.23749 8.25617C4.9565 7.98146 4.79864 7.60913 4.79864 7.22085C4.79864 6.83257 4.9565 6.46023 5.23749 6.18573C5.51849 5.91102 5.89985 5.75682 6.29731 5.75682Z",
    fill: "currentColor"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "buyer_status",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.75C8.31 11.75 7.75 12.31 7.75 13C7.75 13.69 8.31 14.25 9 14.25C9.69 14.25 10.25 13.69 10.25 13C10.25 12.31 9.69 11.75 9 11.75ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.71 4.02 11.42 4.05 11.14C6.41 10.09 8.28 8.16 9.26 5.77C11.07 8.33 14.05 10 17.42 10C18.2 10 18.95 9.91 19.67 9.74C19.88 10.45 20 11.21 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "date_header",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4V1",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4V1",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11H7V13H9V11ZM9 15H7V17H9V15ZM11 11H13V13H11V11ZM13 15H11V17H13V15ZM15 11H17V13H15V11ZM17 15H15V17H17V15Z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "benchmark",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7H11V17H13V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10H15V17H17V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12H7V17H9V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19V5C3 3.897 3.897 3 5 3H19C20.103 3 21 3.897 21 5V19C21 20.103 20.103 21 19 21H5C3.897 21 3 20.103 3 19ZM5 19H19.001L19 5H5V19Z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21.0003C15.3463 20.9988 13.7183 20.5901 12.26 19.8103L11.81 19.5603C8.70075 17.8886 6.15169 15.3395 4.48 12.2303L4.23 11.7803C3.42982 10.3136 3.00713 8.67097 3 7.00027V6.33027C2.99958 5.79723 3.21196 5.28607 3.59 4.91027L5.28 3.22027C5.44413 3.05487 5.67581 2.97514 5.90696 3.00453C6.13811 3.03391 6.34248 3.16906 6.46 3.37027L8.71 7.23027C8.93753 7.62316 8.87183 8.12002 8.55 8.44027L6.66 10.3303C6.50304 10.4855 6.46647 10.7253 6.57 10.9203L6.92 11.5803C8.17704 13.9087 10.0893 15.8175 12.42 17.0703L13.08 17.4303C13.275 17.5338 13.5148 17.4972 13.67 17.3403L15.56 15.4503C15.8802 15.1284 16.3771 15.0627 16.77 15.2903L20.63 17.5403C20.8312 17.6578 20.9664 17.8622 20.9957 18.0933C21.0251 18.3245 20.9454 18.5561 20.78 18.7203L19.09 20.4103C18.7142 20.7883 18.203 21.0007 17.67 21.0003H17Z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.94971C6.48024 1.94971 2.00024 6.42971 2.00024 11.9497C2.00024 17.4697 6.48024 21.9497 12.0002 21.9497H17.0002V19.9497H12.0002C7.66024 19.9497 4.00024 16.2897 4.00024 11.9497C4.00024 7.60971 7.66024 3.94971 12.0002 3.94971C16.3402 3.94971 20.0002 7.60971 20.0002 11.9497V13.3797C20.0002 14.1697 19.2902 14.9497 18.5002 14.9497C17.7102 14.9497 17.0002 14.1697 17.0002 13.3797V11.9497C17.0002 9.18971 14.7602 6.94971 12.0002 6.94971C9.24024 6.94971 7.00024 9.18971 7.00024 11.9497C7.00024 14.7097 9.24024 16.9497 12.0002 16.9497C13.3802 16.9497 14.6402 16.3897 15.5402 15.4797C16.1902 16.3697 17.3102 16.9497 18.5002 16.9497C20.4702 16.9497 22.0002 15.3497 22.0002 13.3797V11.9497C22.0002 6.42971 17.5202 1.94971 12.0002 1.94971ZM12.0002 14.9497C10.3402 14.9497 9.00024 13.6097 9.00024 11.9497C9.00024 10.2897 10.3402 8.94971 12.0002 8.94971C13.6602 8.94971 15.0002 10.2897 15.0002 11.9497C15.0002 13.6097 13.6602 14.9497 12.0002 14.9497Z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5V2",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V2",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye_open",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7833 11.2155L19.9056 11.6947L20.7833 11.2155ZM20.7833 12.7845L19.9056 12.3054L20.7833 12.7845ZM4.09443 11.6946C5.6225 8.89537 8.59063 7 12 7V5C7.82999 5 4.20347 7.32074 2.33895 10.7364L4.09443 11.6946ZM12 7C15.4094 7 18.3775 8.89538 19.9056 11.6947L21.661 10.7364C19.7965 7.32075 16.17 5 12 5V7ZM19.9056 12.3054C18.3775 15.1046 15.4094 17 12 17V19C16.17 19 19.7965 16.6793 21.661 13.2636L19.9056 12.3054ZM12 17C8.59063 17 5.6225 15.1046 4.09443 12.3053L2.33895 13.2636C4.20347 16.6793 7.82999 19 12 19V17ZM19.9056 11.6947C20.0095 11.885 20.0095 12.115 19.9056 12.3054L21.661 13.2636C22.091 12.476 22.091 11.524 21.661 10.7364L19.9056 11.6947ZM2.33895 10.7364C1.90899 11.524 1.90899 12.476 2.33895 13.2636L4.09443 12.3053C3.9905 12.115 3.9905 11.885 4.09443 11.6946L2.33895 10.7364Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "new_insights_briefing",
    viewBox: "0 0 256 86",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.628 43.0206C117.681 39.6022 111.978 39.4642 106.777 39.9222C106.191 39.9737 105.599 40 105 40C102.105 40 99.3541 39.385 96.8701 38.2785C91.7749 36.0089 86.1521 33.7831 80.7946 35.3353L78.7129 35.9384C71.4338 38.0473 68 46.4216 68 54C68 71.6731 53.6731 86 36 86C18.3269 86 4 71.6731 4 54C4 36.3269 18.3269 22 36 22C41.344 22 46.382 23.3099 50.8104 25.6262C56.6397 28.6752 63.2839 30.923 69.6026 29.0923L81.1606 25.7437C83.5987 25.0373 85 22.5384 85 20C85 8.9543 93.9543 0 105 0C116.046 0 125 8.9543 125 20C125 20.1125 124.999 20.2247 124.997 20.3368C124.904 26.0051 125.591 32.2932 129.876 36.0046C133.951 39.5332 139.857 39.5798 145.136 38.4931C146.707 38.1698 148.334 38 150 38C155.004 38 159.65 39.5315 163.496 42.1512C167.345 44.7732 172.157 46.4067 176.508 44.7464L179.089 43.7615C182.213 42.5693 184 39.344 184 36C184 16.1177 200.118 0 220 0C239.882 0 256 16.1177 256 36C256 55.8823 239.882 72 220 72C212.805 72 206.104 69.8895 200.48 66.2539C194.927 62.6634 188.088 60.5164 181.91 62.874C176.801 64.8232 173.435 69.5588 170.638 74.2571C166.453 81.2887 158.777 86 150 86C136.745 86 126 75.2548 126 62C126 61.1095 126.049 60.2303 126.143 59.365C126.786 53.4736 126.108 46.9004 121.628 43.0206Z",
    fill: "#DDF4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15V12H75V60C75 62.209 73.209 64 71 64C68.791 64 67 62.209 67 60V22C67 19.791 65.209 18 63 18C60.791 18 59 19.791 59 22V69L58 70L54 74L50 70L46 74L42 70L38 74L34 70L30 74L26 70L22 74L18 70L17 69V22C17 19.791 18.791 18 21 18H63",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 64H62",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 64H25",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 64H29",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 64H33",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 64H37",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 64H41",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 64H45",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 64H49",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 64H53",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 24H37",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28H55",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 61V43",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 64H21",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 61V43",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 61V53",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 61V41",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 61V47",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 61V49",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 61V43",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 61V51",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 61V39",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 24H55",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 24H22V28H26V24Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 54V72",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 54L148 71V72",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 54L116 71V72",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 25V54H105V25",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 22V18H125L127 14H137L139 18H163V22H101Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 18H135",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 72H164",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 32C126.552 32 127 31.5523 127 31C127 30.4477 126.552 30 126 30C125.448 30 125 30.4477 125 31C125 31.5523 125.448 32 126 32Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 46C136.552 46 137 45.5523 137 45C137 44.4477 136.552 44 136 44C135.448 44 135 44.4477 135 45C135 45.5523 135.448 46 136 46Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 33V31C131 28.238 128.762 26 126 26C123.238 26 121 28.238 121 31V37C121 39.762 118.762 42 116 42H110",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 34H146C143.238 34 141 36.238 141 39V45C141 47.762 138.762 50 136 50C133.238 50 131 47.762 131 45V43",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 38L154 34L150 30",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 35V37",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 39V41",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 26H110",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 26H156",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 50H156",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 50H110",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 75V66",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 66V75",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 61V65C222 65.553 221.553 66 221 66H207C206.447 66 206 65.553 206 65V61",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 62C227.807 62 239 50.8071 239 37C239 23.1929 227.807 12 214 12C200.193 12 189 23.1929 189 37C189 50.8071 200.193 62 214 62Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 31.5C219 35 217.037 38 214 38C210.963 38 209 35 209 31.5C209 28 210 26 214 26C218 26 219 28 219 31.5Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 37L224 41C224 41 224 41.344 224 43C224 44.656 223 46 222 46H206C205 46 204 44.656 204 43C204 41.344 204 41 204 41L211 37",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 69V75",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 58C225.598 58 235 48.598 235 37C235 25.402 225.598 16 214 16C202.402 16 193 25.402 193 37C193 48.598 202.402 58 214 58Z",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 37C198 28.163 205.164 21 214 21",
    stroke: "#36AD86",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "equal",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.92 8.11597V10.348H4.97998V8.11597H19.92ZM19.92 13.984V16.216H4.97998V13.984H19.92Z",
    fill: "currentColor"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_outlined",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 3c.6 0 1 .4 1 1v4a1 1 0 1 1-2 0v-4c0-.6.4-1 1-1Z",
    clipRule: "evenodd"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_filled",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z",
    fill: "currentColor"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_exclamation",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F56B38",
    fillRule: "evenodd",
    d: "M10 18.3a8.3 8.3 0 1 0 0-16.6 8.3 8.3 0 0 0 0 16.6Zm0-8a.7.7 0 0 1-.8-.7V6.3a.8.8 0 0 1 1.5 0v3.3c0 .4-.3.7-.7.7ZM9.2 13a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0Z",
    clipRule: "evenodd"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z",
    fill: "currentColor"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3H10C8.897 3 8 3.897 8 5V6H4V8H6V19C6 20.103 6.897 21 8 21H16C17.103 21 18 20.103 18 19V8H20V6H16V5C16 3.897 15.103 3 14 3ZM10 5H14V6H10V5ZM16 19H8V8H16V19Z",
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "plusCircle",
    viewBox: "0 0 25 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 13L11.5 17H13.5V13H17.5V11H13.5V7H11.5L11.5 11H7.5V13H11.5Z",
    fill: "currentColor"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20L16 16",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "help_filled",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM9.3 7C10 6.3 11 6 12 6a3.9 3.9 0 0 1 4 4c0 1.8-1.1 2.7-2 3.2l-.3.3-.6.3-.1.2a1 1 0 0 1-2 0c0-.8.4-1.3.8-1.6l1-.7.1-.1c.7-.5 1.1-.9 1.1-1.6a2 2 0 0 0-.6-1.5C13 8.2 12.5 8 12 8c-.5 0-1 .2-1.4.5A2 2 0 0 0 10 10a1 1 0 1 1-2 0c0-1.3.5-2.3 1.3-3ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    clipRule: "evenodd"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "face",
    viewBox: "0 0 24 24",
    fill: "#2E9372"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8a1.3 1.3 0 1 0 0 2.5 1.3 1.3 0 0 0 0-2.6Zm6 0a1.3 1.3 0 1 0 0 2.5 1.3 1.3 0 0 0 0-2.6ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 0 1-8-8.9c2.4-1 4.3-3 5.3-5.3a10 10 0 0 0 10.4 4A8 8 0 0 1 12 20Z"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "video_settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12L9 8V16L15 12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 1,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "live_help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm-6 16h-2v-2h2v2Zm2-7.8-.8 1c-.8.7-1.2 1.3-1.2 2.8h-2v-.5a4 4 0 0 1 1.2-2.8l1.2-1.3c.4-.3.6-.8.6-1.4a2 2 0 0 0-2-2 2 2 0 0 0-2 2H8a4 4 0 1 1 8 0c0 .9-.4 1.7-1 2.3Z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "ppt",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2c-.88 0-1.6.72-1.6 1.6v16.8c0 .88.72 1.6 1.6 1.6h13c.88 0 1.6-.72 1.6-1.6V3.6 7l-5-5H5.5Z",
    fill: "#FF9333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64 17v-3.07h2.19c1.71 0 2.58-.74 2.58-2.22 0-1.47-.85-2.21-2.57-2.21H9.8V17h.85Zm2.15-3.81h-2.15v-2.94h2.15c.6 0 1.03.11 1.33.36.29.22.44.6.44 1.1 0 .5-.15.87-.43 1.1-.3.25-.74.38-1.34.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 7h3.4l-5-5v3.4c0 .88.72 1.6 1.6 1.6Z",
    fill: "#E36334"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fill: "#E36334",
    d: "M19.63 6.53h-4.06l4.53 4.53V7l-.47-.47Z"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "ppt-error",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78 4.63a1.6 1.6 0 0 1 1.37-1.8l2.37-.34 2.38-.32 2.08 6.27-.66 6.15L12 19.4 10.1 22.2l-3.21.44a1.6 1.6 0 0 1-1.81-1.36L2.79 4.63Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 22.73a1.6 1.6 0 0 0 1.77-1.4l1.56-13.31-4.4-5.55L13.33 2l.73 6.63-1.68 5.84 1.4 5.2L12 21.98l6.46.75Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 7.5-4.03-.47 3.98 5.03.47-4.04-.42-.52Z",
    fill: "#43494D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4 7.63 3.38.4-4.4-5.55L17 5.85a1.6 1.6 0 0 0 1.4 1.78Z",
    fill: "#43494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.83 13.93c1.71 0 2.58-.74 2.58-2.22 0-1.18-.54-1.88-1.64-2.12l-.2.74c.22.07.4.16.55.28.29.22.44.6.44 1.1 0 .5-.15.87-.43 1.11-.3.24-.79.36-1.4.36l-.2.75h.3ZM8.46 14.16l.31 3.05-.85.09-.76-7.47 3.03-.3c.35-.04.4-.05.68-.02l-.08.76c-.23-.04-.28-.03-.57 0l-2.14.22.3 2.92 2.1-.31-.09.79-1.93.27Z",
    fill: "#CBD1D6"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "excel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41C499",
    fillRule: "evenodd",
    d: "M5.5 2c-.9 0-1.6.7-1.6 1.6v16.8c0 .9.7 1.6 1.6 1.6h13c.9 0 1.6-.7 1.6-1.6V7l-5-5H5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.8 17 2.2-3.2 2.3 3.2h1l-2.8-3.9 2.6-3.6h-1l-2.1 3-2-3H8.8l2.6 3.6L8.7 17h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26795E",
    d: "M16.7 7h3.4l-5-5v3.4c0 .9.7 1.6 1.6 1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#26795E",
    d: "M19.6 6.5h-4l4.5 4.6V7l-.5-.5Z"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "excel-error",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78 4.63a1.6 1.6 0 0 1 1.37-1.8l2.37-.34 2.38-.32 2.08 6.27-.66 6.15L12 19.4 10.1 22.2l-3.21.44a1.6 1.6 0 0 1-1.81-1.36L2.79 4.63Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 22.73a1.6 1.6 0 0 0 1.77-1.4l1.56-13.31-4.4-5.55L13.33 2l.73 6.63-1.68 5.84 1.4 5.2L12 21.98l6.46.75Z",
    fill: "#98A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.36 7.5-4.03-.47 3.98 5.03.47-4.04-.42-.52Z",
    fill: "#43494D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4 7.63 3.38.4-4.4-5.55L17 5.85a1.6 1.6 0 0 0 1.4 1.78Z",
    fill: "#43494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 12.95 1.24 3.72 1.03.3-1.58-4.53L17 9.72l-1.02-.3-2.8 2.22-.38 1.31ZM10.49 13.1l-1.85 3.36-1.06.12 2.3-4.2-2.99-3.27 1.06-.13 2.67 2.84-.13 1.28Z",
    fill: "#CBD1D6"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.75v3.67a1.83 1.83 0 0 1-1.83 1.83H5.58a1.83 1.83 0 0 1-1.83-1.83v-3.67",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42 10.17 12 14.75l4.58-4.58",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.83V3.75",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-download-spinner",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 16.5c.47.28.64.9.32 1.34A10 10 0 0 1 2.88 7.89c.23-.5.85-.67 1.33-.39.47.28.63.89.42 1.4a8 8 0 0 0 13.75 7.93c.33-.44.94-.6 1.41-.33Z",
    fill: "currentColor"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "download-spinner",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 3.33965c4.7829 2.76142 6.4217 8.87735 3.6603 13.66025-2.7615 4.7829-8.8774 6.4217-13.6603 3.6603C2.21717 17.8987.57842 11.7828 3.33984 6.9999 6.10127 2.21698 12.2172.57822 17.0001 3.33965Zm-9 15.58845c3.8263 2.2091 8.7191.8981 10.9282-2.9282 2.2091-3.8263.8981-8.71906-2.9282-10.9282-3.8263-2.20914-8.71907-.89814-10.92821 2.9282-2.20913 3.8263-.89813 8.7191 2.92821 10.9282Z",
    fill: "#68D0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c0-.55228.4488-1.00519.9984-.95007 2.2855.22925 4.4341 1.24045 6.0727 2.879C20.9464 6.8043 22 9.34783 22 12c0 2.6522-1.0536 5.1957-2.9289 7.0711-1.6386 1.6385-3.7872 2.6497-6.0727 2.879C12.4488 22.0052 12 21.5523 12 21s.4495-.9935.9974-1.0624c1.754-.2204 3.3962-1.0175 4.6595-2.2807C19.1571 16.1566 20 14.1217 20 12c0-2.12173-.8429-4.15656-2.3431-5.65685-1.2633-1.26325-2.9055-2.06039-4.6595-2.28076C12.4495 3.99355 12 3.55228 12 3Z",
    fill: "#fff"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "repeat",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.1a5 5 0 0 1-3.3-1.2A5 5 0 0 1 3 9h1.6A3.5 3.5 0 0 0 8 11.6c1 0 1.8-.4 2.5-1 .7-.8 1-1.6 1-2.6s-.3-1.8-1-2.5-1.5-1-2.5-1a3.5 3.5 0 0 0-2.5 1H7V7H2.9V2.9h1.5v1.5A5.3 5.3 0 0 1 8 2.9a5 5 0 0 1 3.6 1.5A5 5 0 0 1 13.1 8a5 5 0 0 1-1.5 3.6A5 5 0 0 1 8 13.1Z"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-downloaded",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#36AD86",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#36AD86",
    strokeWidth: 1.5,
    d: "M5 7.7 7.3 10 11 6.3"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-ready",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#36AD86",
    strokeWidth: 1.5
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "status-failed",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 10.3333L10.3332 5.66666",
    stroke: "#F56B38",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 5.66666L10.3332 10.3333",
    stroke: "#F56B38",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#F56B38",
    strokeWidth: 1.5
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-file-reject",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 17 6-6M9 11l6 6",
    stroke: "#CBD1D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4v16c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V7.4a1 1 0 0 0-.3-.7l-3.4-3.4a1 1 0 0 0-.7-.3H6a1 1 0 0 0-1 1Z",
    stroke: "#CBD1D6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V3l5 5h-4a1 1 0 0 1-1-1Z",
    fill: "#CBD1D6"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron_down_small",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 10 4 4 4-4",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check_medium",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 11.86 3.57 3.57L17 9",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bar_chart_horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h2v18H3V3ZM21 11V9H6v2h15ZM13 7V5H6v2h7ZM18 13v2H6v-2h12ZM15 19v-2H6v2h9Z"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location_outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14ZM12 2c4.2 0 8 3.22 8 8.2 0 3.18-2.45 6.93-7.35 11.24a.98.98 0 0 1-1.3 0C6.45 17.13 4 13.38 4 10.2 4 5.22 7.8 2 12 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.aef25e48a503dad3d29a1cb041877492.svg";
export { ForwardRef as ReactComponent };